import { LockKeyhole } from "lucide-react";

import { Badge } from "./Badge";

export function ReadOnlyBadge() {
  return (
    <Badge color="muted" dot={false}>
      <LockKeyhole size={12} />
      Solo lectura
    </Badge>
  );
}
